// extracted by mini-css-extract-plugin
export var border = "_9-8";
export var brand = "_9-t";
export var button = "_9-l";
export var center = "_9-a";
export var centered = "_9-6";
export var closeButton = "_9-c";
export var disabledWrapper = "_9-m";
export var error = "_9-p";
export var extraLarge = "_9-4";
export var extraSmall = "_9-1";
export var fill = "_9-i";
export var footer = "_9-h";
export var footerAction = "_9-j";
export var footerButtons = "_9-k";
export var header = "_9-7";
export var headerWithClose = "_9-d";
export var icon = "_9-o";
export var info = "_9-s";
export var inline = "_9-9";
export var large = "_9-3";
export var main = "_9-e";
export var modal = "_9-0";
export var nearFull = "_9-5";
export var neutral = "_9-u";
export var noPadding = "_9-g";
export var none = "_9-v";
export var scrollable = "_9-f";
export var small = "_9-2";
export var success = "_9-r";
export var tight = "_9-n";
export var titleIcon = "_9-b";
export var warn = "_9-q";